import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CollapseModule } from 'ngx-bootstrap';

import { AtxCollapseComponent } from './components';

@NgModule({
    imports: [
        CommonModule,
        CollapseModule
    ],
    declarations: [
        AtxCollapseComponent,
    ],
    exports: [
        AtxCollapseComponent,
    ],
})

export class AtxCollapseModule {}
